





























import Vue from "vue";
import Lottie from "vue-lottie";
import * as welcome from "@/assets/lottie/welcome.json";
export default Vue.extend({
  name: "IntroductionForFaceUp",
  components: {
    Lottie
  },
  data() {
    return {
      lottie1Options: {
        // @ts-ignore
        animationData: welcome.default
      },
      loading: false,
      mediaSize: 100
    };
  }
});
